import Permission from './permission.js';
export default Permission;